module.exports = __webpack_public_path__ + "img/rem12.e32c14a0.jpg";